/* T22 SPARAT (2026-10-10): hjärta på varje produktkort, hjärtat med räknare i sidhuvudet och Sparat-sidan.
   Samma lista som produktsidans Spara-knapp och kontopanelen: localStorage "t22-sparade" (produktens handle,
   senast sparad först, högst 24). Sparas i webbläsaren; ingen app och inget konto. Följer alltså inte med
   mellan mobil och dator (det kräver en app eller egen server).
   Löparhjärtat (2026-10-11): ikonen kommer ur <template data-t22-hjarta-mall> i t22-header (snippets/t22-hjarta-ikon),
   samma som sidhuvudet och produktsidan. Hjärtan läggs på startsidans kort (.t22-kort) och kategori-/sökkort (.kk-kort). */
(function () {
  var NYCKEL = 't22-sparade';
  var mall = document.querySelector('template[data-t22-hjarta-mall]');
  var HJARTA = mall ? mall.innerHTML : '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2" d="M12 21s-7-4.5-9.5-9C.7 8.6 2.4 4.5 6.5 4.5c2.1 0 3.6 1 5.5 3.1 1.9-2.1 3.4-3.1 5.5-3.1 4.1 0 5.8 4.1 4 7.5C19 16.5 12 21 12 21z"/></svg>';

  function las() {
    try { var x = JSON.parse(localStorage.getItem(NYCKEL) || '[]'); return Array.isArray(x) ? x : []; } catch (e) { return []; }
  }
  function spara(l) { try { localStorage.setItem(NYCKEL, JSON.stringify(l.slice(0, 24))); } catch (e) {} }
  function handleFran(href) {
    var m = /\/products\/([^\/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function kr(oren) {
    var t = (oren / 100).toFixed(2).replace('.', ',').replace(',00', '');
    return t.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
  }

  function ritaHjartan() {
    var lista = las();
    document.querySelectorAll('.t22-hjarta').forEach(function (b) {
      var p = lista.indexOf(b.getAttribute('data-handle')) !== -1 ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== p) b.setAttribute('aria-pressed', p);
    });
    /* Sidhuvudets hjärta springer när något är sparat */
    document.querySelectorAll('.t22-ikon--sparat').forEach(function (a) {
      a.classList.toggle('t22-hj-pa', lista.length > 0);
      a.setAttribute('aria-label', lista.length ? 'Sparat, ' + lista.length + (lista.length === 1 ? ' produkt' : ' produkter') : 'Sparat');
    });
    document.querySelectorAll('[data-t22-sparat-antal]').forEach(function (el) {
      el.textContent = lista.length;
      if (lista.length) el.removeAttribute('data-tom'); else el.setAttribute('data-tom', '');
    });
  }

  function laggHjartan() {
    document.querySelectorAll('.t22-kort:not([data-hj]), .kk-kort:not([data-hj])').forEach(function (kort) {
      kort.setAttribute('data-hj', '1');
      var a = kort.querySelector('a.t22-kort__l, a.kk-kort__l');
      var h = a && handleFran(a.getAttribute('href'));
      if (!h) return;
      var namn = kort.getAttribute('data-namn') || (kort.querySelector('.t22-kort__namn') || {}).textContent || h;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 't22-hjarta';
      b.setAttribute('data-handle', h);
      b.setAttribute('aria-label', 'Spara ' + namn.trim());
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML = HJARTA;
      kort.appendChild(b);
    });
    ritaHjartan();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.t22-hjarta') : null;
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      var h = b.getAttribute('data-handle');
      var l = las(), i = l.indexOf(h);
      if (i === -1) l.unshift(h); else l.splice(i, 1);
      spara(l);
      ritaHjartan();
      ritaSida();
      try { document.dispatchEvent(new CustomEvent('t22-sparat')); } catch (x) {}
      return;
    }
    /* Produktsidans egen Spara-knapp skriver samma lista; läs om efteråt */
    if (e.target.closest && e.target.closest('[data-spara]')) setTimeout(function () { ritaHjartan(); ritaSida(); }, 0);
  });
  window.addEventListener('storage', function (e) { if (e.key === NYCKEL) { ritaHjartan(); ritaSida(); } });

  /* Sparat-sidan */
  var sidaKlar = false;
  function ritaSida() {
    var box = document.querySelector('[data-t22-sparatsida]');
    if (!box) return;
    var rad = box.querySelector('[data-t22-sparat-rad]');
    var tom = box.querySelector('[data-t22-sparat-tom]');
    var handles = las();
    if (!handles.length) { rad.innerHTML = ''; if (tom) tom.hidden = false; return; }
    if (tom) tom.hidden = true;
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (lista) {
      var html = '';
      lista.forEach(function (p) {
        if (!p) return;
        var bild = p.featured_image ? p.featured_image.replace(/^\/\//, 'https://') : '';
        if (bild) bild += (bild.indexOf('?') > -1 ? '&' : '?') + 'width=500';
        html += '<div class="t22-kort"><a class="t22-kort__l" href="/products/' + esc(p.handle) + '"><div class="t22-kort__bild">' +
          (bild ? '<img src="' + esc(bild) + '" alt="' + esc(p.title) + '" loading="lazy" width="300" height="300">' : '') +
          '</div>' + (p.vendor ? '<span class="t22-kort__marke">' + esc(p.vendor) + '</span>' : '') +
          '<span class="t22-kort__namn">' + esc(p.title) + '</span>' +
          '<span class="t22-kort__pris">' + (p.price_varies ? 'Från ' : '') + kr(p.price) + '</span></a>' +
          '<a class="t22-lagg" href="/products/' + esc(p.handle) + '"><span>Visa produkten</span></a></div>';
      });
      rad.innerHTML = html;
      sidaKlar = true;
      laggHjartan();
    });
  }

  function start() {
    laggHjartan();
    ritaSida();
    /* Kort som kommer in senare (filter, ladda fler) */
    var vantar = false;
    new MutationObserver(function () {
      if (vantar) return;
      vantar = true;
      setTimeout(function () { vantar = false; laggHjartan(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
